import React, { useState } from "react";
import "../../global-styles.css";

import { Adicionar } from "./adicionar-style";
import api from "../../services/api";
import Modal from "../modal/modal.js";

import ReactLoading from "react-loading";
import ErrorMessage from "../ErrorMessage";
import { TextoClicavel } from "../modalAdicionar/adicionar-style.js";
import { TextAreaModal, TextDivModal } from "../TextField/styles";
import { Colors } from "../../utils/theme/constants";

function AdicionarCategoria({ GetCategorias }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [messageIsOpen, setMessageIsOpen] = useState(false);
  const [nome, setNome] = useState("");
  const [imagem, setImagem] = useState([]);
  const [nomeImagem, setNomeImagem] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);


  const [nameErro, setNameErro] = useState(false);
  const [apiError, setApiError] = useState("");

  const getApiErrorMessage = (error) => {
    const data = error?.response?.data;
    return (
      (data &&
        (data.nome?.[0] ||
          data.detail ||
          (typeof data === "string" ? data : null))) ||
      "Não foi possível salvar. Tente novamente."
    );
  };

  const checkErrors = () => {
    let hasErrors = false;
    if (nome === "") {
      setNameErro(true);
      hasErrors = true;
    } else {
      setNameErro(false);
    }

    return hasErrors;
  };

  const adicionarCategoria = async (e) => {
    e.preventDefault();

    if (checkErrors()) return;

    setLoading(true);
    setApiError("");
    try {
      const response = await api.get("/auth/users/me/");
      const bodyHistory = {
        user: response.data.id,
        model_name: nome,
        model_type: "Categoria",
        operation: "+",
      };
      await api.post("/api/editionhistory/", bodyHistory);
    } catch (error) {
      console.log(error);
    }

    const body = {
      nome: nome,
      image_url: nomeImagem,
    };

    try {
      await api.post("/api/categorias/", body);
      GetCategorias();
      setModalIsOpen(false);
      setMessageIsOpen(true);
    } catch (error) {
      console.log(error);
      setApiError(getApiErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (e) => {
    e.preventDefault();
    if (!imagem?.type) return;
    const typeNovo = imagem.type.substring(6);
    setNomeImagem("");
    setLoadingUpload(true);
    try {
      const res = await api.get("/api/file/upload/" + typeNovo + "/");
      setNomeImagem(res.data.file_name);
      const formData = new FormData();
      formData.append("file_name", res.data.file_name);
      formData.append("file", imagem);

      await api.post("/api/file/upload/" + typeNovo + "/", formData);
    } catch (err) {
      console.error(err);
      setApiError("Falha ao enviar a imagem.");
    } finally {
      setLoadingUpload(false);
    }
  };

  return (
    <Adicionar>
      <button type="button" onClick={() => setModalIsOpen(true)}>
        <p style={{ color: Colors.White }}>Adicionar Categoria</p>
        {/* <img src={Plus} alt="Mais" /> */}
      </button>

      {modalIsOpen ? (
        <Modal
          container="containerAdicionar"
          onClose={() => {
            setModalIsOpen(false);
            setApiError("");
          }}
        >
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            Adicionar Categoria
          </p>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <label htmlFor="nome">
              Nome<strong style={{ color: "red" }}>*</strong>
            </label>
            <TextDivModal height="40">
              <TextAreaModal
                type="text"
                id="nome"
                value={nome}
                onChange={(event) => setNome(event.target.value)}
              />
            </TextDivModal>

            <ErrorMessage isVisible={nameErro} message="Preencha o Nome" />

            <label htmlFor="imagem">Imagem</label>
            <input
              type="file"
              onChange={(event) => setImagem(event.target.files[0])}
              accept="image/*"
            />

            {loadingUpload && (
              <ReactLoading
                type="spokes"
                color="#E6AC86"
                height={20}
                width={20}
              />
            )}
            <TextoClicavel>
              <button className="confirmar" onClick={(e) => uploadFile(e)}>
                Confirmar imagem
              </button>
            </TextoClicavel>

            <button
              type="submit"
              onClick={(e) => adicionarCategoria(e)}
              className="enviar"
              style={{ cursor: "pointer" }}
            >
              {loading ? (
                <ReactLoading type="spin" color="#fff" height={20} width={20} />
              ) : (
                "Adicionar"
              )}
            </button>

            <ErrorMessage isVisible={!!apiError} message={apiError} />
          </form>
        </Modal>
      ) : null}

      {messageIsOpen ? (
        <Modal
          container="containerAviso"
          onClose={() => {
            setMessageIsOpen(false);
            GetCategorias();
          }}
        >
          <p>Categoria Adicionada com Sucesso!</p>
        </Modal>
      ) : null}
    </Adicionar>
  );
}
export default AdicionarCategoria;
